<ng-container *ngIf="authService.canAccessSales && (!routeService.isWindow || routeService.header.date || cartService.ticketCount)">
  <ng-container *ngIf="!isDisabled">
    <ng-container *ngIf="utilService.isMobile">
      <a class="menu-action" [routerLink]="['/app/sales-terminal/cart']">
        <ng-container [ngTemplateOutlet]="cartMenuButtonContent"></ng-container>
      </a>
    </ng-container>
    <ng-container *ngIf="!utilService.isMobile">
      <a class="menu-action" #cartMenuTrigger [matMenuTriggerFor]="cartMenu" [ngClass]="{'active': isOpen}"
         (onMenuOpen)="handleCartOpen()" (onMenuClose)="handleCartClose()">
        <ng-container [ngTemplateOutlet]="cartMenuButtonContent"></ng-container>
      </a>
    </ng-container>
    <ng-template #cartMenuButtonContent>
      <div class="menu-action-content">
        <mat-icon class="svg-icon" [svgIcon]="'cart'"></mat-icon>
        <span class="cart-number" *ngIf="cartService.ticketCount">
          {{ routeService.isWindow ? (cartService.totalSum | price) : cartService.ticketCount }}
        </span>
        <span class="cart-number" *ngIf="!cartService.ticketCount">
          <mat-icon class="svg-icon cart-icon" [svgIcon]="'favourite'"></mat-icon>
        </span>
      </div>
    </ng-template>
  </ng-container>
  <a class="menu-action disabled" *ngIf="isDisabled">
    <div class="menu-action-content">
      <mat-icon class="svg-icon" [svgIcon]="'cart'"></mat-icon>
      <span class="cart-number"></span>
    </div>
  </a>
</ng-container>
<mat-menu class="mat-menu cart-menu" #cartMenu="matMenu" yPosition="below" xPosition="before">
  <app-loader [loading]="cartService.isLoading || ticketTypeService.typesLoading" [overlay]="true"></app-loader>
  <div class="cart-menu-wrapper">
    <div class="cart-content">
      <app-cart-timer></app-cart-timer>
      <div class="flex space-between">
        <div class="heading-3 left-spacer">{{'general.api_cart_contents' | translate}}</div>
        <button mat-button class="input-button bottom-spacer right-spacer" (click)="$event.stopPropagation(); confirmClear()">
          <mat-icon class="svg-icon" [svgIcon]="'trash'"></mat-icon>
          {{ 'general.api_cart_clear' | translate }}
        </button>
      </div>
      <table class="report-table bottom-spacer body-3" border="0" (click)="$event.stopPropagation()">
        <thead>
        <tr>
          <th>{{'general.api_cart_table_type' | translate}}</th>
          <ng-container *ngIf="!cartService.isSelfService">
            <th>{{'general.api_cart_table_sector' | translate}}</th>
            <th>{{'general.api_cart_table_row' | translate}}</th>
            <th>{{'general.api_cart_table_seat' | translate}}</th>
            <th class="align-right">{{ 'general.api_cart_table_price' | translate }}</th>
          </ng-container>
          <ng-container *ngIf="cartService.isSelfService">
            <th class="min-width align-right">{{ 'general.api_cart_table_price' | translate }}</th>
            <th class="min-width align-right">{{ 'general.api_cart_table_quantity' | translate }}</th>
            <th class="min-width align-right">{{ 'general.api_cart_table_total' | translate }}</th>
          </ng-container>
          <th class="min-width" *ngIf="!routeService.isWindow">&nbsp;</th>
        </tr>
        </thead>
        <tbody>
        <ng-container *ngFor="let cartEvent of cartService.events">
          <tr class="body-4 text-muted">
            <th [colSpan]="(!routeService.isWindow ? 3 : 2) + (!cartService.isSelfService ? 1 : 0)">
              {{'general.api_cart_table_event_title' | translate}}
            </th>
            <th colspan="2" class="align-right text-muted">
              {{'general.api_cart_table_event_promocode' | translate}}
            </th>
          </tr>
          <tr>
            <td [colSpan]="(!routeService.isWindow ? 3 : 2) + (!cartService.isSelfService ? 1 : 0)">
              <span class="title">{{ (cartEvent.title | translateValue) | toPlainText: 50 }}</span><br>
              <small class="text-muted" *ngIf="!cartEvent.isSeason">{{ cartEvent.eventDate | period: {hasTimeInPeriod: true} }}</small>
            </td>
            <td colspan="2" class="align-right">
              <mat-chip-listbox class="flex flex-end" *ngIf="cartEvent.promocode">
                <mat-chip-option [selectable]="false">
                  {{ cartEvent.promocode }}
                  <button matChipRemove (click)="removePromocode(cartEvent.id)" [disabled]="cartService.isLoading">
                    <mat-icon class="svg-icon" [svgIcon]="'close'"></mat-icon>
                  </button>
                </mat-chip-option>
              </mat-chip-listbox>
            </td>
          </tr>
          <tr *ngFor="let ticket of cartEvent.legacyTickets">
            <td class="break-word">{{ ticket.priceTypeName | translate }}</td>
            <td>{{ (ticket.sectorName | translate) !== ticket.sectorName ? (ticket.sectorName | translate | toPlainText:15) : ticket.sectorId }}</td>
            <td>{{ ticket.row }}</td>
            <td>{{ ticket.place }}</td>
            <td class="align-right white-space-no-wrap">
              <span class="title">{{ ticket | ticketPrice }}</span>
            </td>
            <td *ngIf="!routeService.isWindow" class="align-right">
              <button mat-button class="input-button small icon-button" (click)="$event.stopPropagation(); removeTicket(ticket.id)">
                <mat-icon class="svg-icon" [svgIcon]="'trash'"></mat-icon>
              </button>
            </td>
          </tr>
          <tr *ngFor="let ticketType of cartEvent.unassignedTickets">
            <td class="break-word">{{ ticketType.name | translateValue }}</td>
            <td class="align-right white-space-no-wrap">{{ ticketType.price | price }}</td>
            <td class="align-right white-space-no-wrap">
              <app-add-remove [alignRight]="true" [count]="ticketTypeService.typeQuantities[ticketType.ticketTypeUuid]" [autoBind]="true"
                              [max]="getTicketTypeMax(ticketType.ticketTypeUuid, cartEvent.id)"
                              (countChange)="changeTicketTypeCount(cartEvent.id, ticketType.ticketTypeUuid, $event)"></app-add-remove>
            </td>
            <td class="align-right white-space-no-wrap">
              <span class="title">{{ (ticketType.price * ticketType.quantity) | price }}</span>
            </td>
            <td *ngIf="!routeService.isWindow" class="align-right">
              <button mat-button class="input-button small icon-button" (click)="$event.stopPropagation(); removeTicketType(ticketType.ticketTypeUuid, ticketType.quantity, cartEvent.id)">
                <mat-icon class="svg-icon" [svgIcon]="'trash'"></mat-icon>
              </button>
            </td>
          </tr>
        </ng-container>
        </tbody>
      </table>
      <div class="max-width align-right bottom-spacer heading-5" *ngIf="cartService.ticketCount">
        <span class="medium">{{ (cartService.totalSum >= 0 ? 'general.api_cart_table_total' : 'general.api_cart_table_total_return') | translate }}:&nbsp;</span>
        <span class="right-spacer">{{ cartService.totalSum | price }}</span>
      </div>
      <div class="max-width align-right bottom-spacer heading-5" *ngIf="!cartService.ticketCount">
        <span class="medium right-spacer">{{ 'general.api_cart_no_tickets_added_yet' | translate }}</span>
      </div>
    </div>
    <div class="cart-actions" *ngIf="cartService.isSelfService || cartService.ticketCount">
      <button mat-stroked-button color="primary" class="right-spacer" *ngIf="canCreateBookingFromMenu"
              [routerLink]="'sales-terminal/cart/create-booking'">
        {{ 'general.api_cart_add_to_booking' | translate }}
      </button>
      <button mat-flat-button color="primary" *ngIf="!routeService.isWindow" [routerLink]="'sales-terminal/cart'">
        {{ 'general.api_cart_checkout' | translate }}
      </button>
      <button mat-flat-button color="primary" *ngIf="routeService.isWindow" (click)="windowGoToCart()">
        {{ 'general.api_cart_checkout' | translate }}
      </button>
    </div>
  </div>
</mat-menu>
